export default __webpack_public_path__ + "static/aroundH4c1-436385d29efac2b3426e9f267f14848b.png";